import React, { useState, useMemo, useContext } from "react";
import { Redirect, useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteMarketMembershipOrder, downloadFile, putMarketMembershipOrder } from "services/ConfigServices";
import useServiceOrderTable from "./useServiceOrderTable.js";
import EditServiceOrderDialog from "./EditServiceOrderDialog";
import EditServiceOrderStatusDialog from "./EditServiceOrderStatusDialog";
import ValidateServiceOrderDialog from "./ValidateServiceOrderDialog";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import CustomConfirmationButtonMultipleChoices from "components/CustomButtons/CustomConfirmationButtonMultipleChoices.js";
import CustomConfirmationButton from "components/CustomButtons/CustomConfirmationButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { memberorder } from "variables/markets";
import {
  memberorderTypeData,
  memberorderStatusData,
  memberorderElectricitySegment,
  memberorderElectricityTurpeVersionC5,
  memberorderElectricityTurpeVersionC4C3C2,
  memberorderElectricityTurpeVersionC5Ecl,
  memberorderElectricityEclHourCount,
  memberorderElectricityRenewableMix,
  memberorderGasProfil,
  memberorderGasTariff
} from "variables/lists/markets";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import MarketsContext from "context/MarketsContext";
import SendServiceOrderDialog from "./SendServiceOrderDialog"
import AddMeterToAccountDialog from "./AddMeterToAccountDialog.js";
import EditMeterAccountDialog from "./EditMeterAccountDialog.js";

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementSectionTitle = styled.div`
  font-weight: 600;
  font-size: 13px;
  font-family: "Source Sans Pro",sans-serif;
  text-decoration: underline;
  margin-top: 10px;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const ElementDataDownload = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
  cursor: pointer;
  text-decoration: underline;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const ExpandableComponent = props => {
  const { data } = props;
  const ordertype = data.parameters?.ordertype;
  const marketContext = useContext(MarketsContext);
  const { market, setMarket } = marketContext;
  console.log(data);
  return (
    <Container>
      <ExpandableContainer>
        <ElementSectionTitle>Information générales</ElementSectionTitle>
        <ExpandableElement>
          <ElementTitle>{memberorder.ordertype} : </ElementTitle>
          <ElementData>{data.parameters?.ordertype && memberorderTypeData.find((x) => x.id == data.parameters?.ordertype).name}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberorder.creationdate} : </ElementTitle>
          <ElementData>{data.parameters.creationdate && moment(data.parameters.creationdate).isValid()
            ? moment(data.parameters.creationdate).format("DD/MM/YYYY hh:mm")
            : ""}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberorder.status} : </ElementTitle>
          <ElementData>{data.parameters?.status && <div style={{ color: memberorderStatusData.find((x) => x.id == data.parameters.status).color, fontWeight: "bold" }}>
            {memberorderStatusData.find((x) => x.id == data.parameters.status).name}</div>}
          </ElementData>
        </ExpandableElement>
        {data.parameters?.validationdate &&
          <ExpandableElement>
            <ElementTitle>{memberorder.validationdate} : </ElementTitle>
            <ElementData>{data.parameters.validationdate && moment(data.parameters.validationdate).isValid()
              ? moment(data.parameters.validationdate).format("DD/MM/YYYY hh:mm")
              : ""}</ElementData>
          </ExpandableElement>
        }
        {data.parameters?.generatedfile &&
          <ExpandableElement>
            <ElementTitle>{memberorder.generatedfile} : </ElementTitle>
            <ElementDataDownload onClick={downloadGED(data.parameters?.generatedfile.fileId, data.parameters?.generatedfile.fileName)}>{data.parameters?.generatedfile.fileName}</ElementDataDownload>
          </ExpandableElement>
        }
        <ExpandableElement>
          <ElementTitle>{memberorder.marketmembershipnumber} : </ElementTitle>
          <ElementData>{data.parameters?.marketmembershipnumber}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberorder.marketmembershipname} : </ElementTitle>
          <ElementData>{data.parameters?.marketmembershipname}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberorder.marketmembershipaddress} : </ElementTitle>
          <ElementData>{data.parameters?.marketmembershipaddress?.description}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberorder.marketmembershipsiret} : </ElementTitle>
          <ElementData>{data.parameters?.marketmembershipsiret}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberorder.numeroaffaire} : </ElementTitle>
          <ElementData>{data.parameters?.numeroaffaire}</ElementData>
        </ExpandableElement>

        <ElementSectionTitle>Référent technique</ElementSectionTitle>
        <ExpandableElement>
          <ElementTitle>{memberorder.referentname} : </ElementTitle>
          <ElementData>{data.parameters?.referentname}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberorder.referentemail} : </ElementTitle>
          <ElementData>{data.parameters?.referentemail}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberorder.referentphone} : </ElementTitle>
          <ElementData>{data.parameters?.referentphone}</ElementData>
        </ExpandableElement>

        {(ordertype === 'detach' || ordertype === 'change') ?
          <>
            <ElementSectionTitle>Informations du Point de livraison à modifier</ElementSectionTitle>
            <ExpandableElement>
              <ElementTitle>{memberorder.pdl} : </ElementTitle>
              <ElementData>{data.parameters?.pdl}</ElementData>
            </ExpandableElement>
            <ExpandableElement>
              <ElementTitle>{memberorder.pdlname} : </ElementTitle>
              <ElementData>{data.parameters?.pdloldname}</ElementData>
            </ExpandableElement>
            <ExpandableElement>
              <ElementTitle>{memberorder.pdladdress} : </ElementTitle>
              <ElementData>{data.parameters?.pdloldaddress?.description}</ElementData>
            </ExpandableElement>
            {/* <ExpandableElement>
              <ElementTitle>{memberorder.pdlusagecode} : </ElementTitle>
              <ElementData>{data.parameters?.pdloldusagecode}</ElementData>
            </ExpandableElement> */}
            <ExpandableElement>
              <ElementTitle>{memberorder.pdlinseecode} : </ElementTitle>
              <ElementData>{data.parameters?.pdlinseecode}</ElementData>
            </ExpandableElement>
          </>
          :
          <>
          </>
        }

        {(ordertype === 'detach') ?
          <>
            <ExpandableElement>
              <ElementTitle>{memberorder.enddate} : </ElementTitle>
              <ElementData>{data.parameters.enddate && moment(data.parameters.enddate).isValid()
                ? moment(data.parameters.enddate).format("DD/MM/YYYY")
                : ""}</ElementData>
            </ExpandableElement>
            <ExpandableElement>
              <ElementTitle>{memberorder.pdldropmeter} : </ElementTitle>
              <ElementData>{data.parameters?.pdldropmeter ? 'Oui' : 'Non'}</ElementData>
            </ExpandableElement>
          </>
          :
          <>
            {(ordertype === 'change') &&
              <>
                <>
                  <ElementSectionTitle>Données contractuelles actuelles</ElementSectionTitle>
                  {(market?.parameters?.general?.energy === 'electricity') &&
                    <>
                      <ExpandableElement>
                        <ElementTitle>{memberorder.electricity.pdltype} : </ElementTitle>
                        <ElementData>{data.parameters?.pdloldcontractualdata?.pdltype && memberorderElectricitySegment.find((x) => x.id == data.parameters?.pdloldcontractualdata?.pdltype).name}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{memberorder.electricity.turpe} : </ElementTitle>
                        <ElementData>{data.parameters?.pdloldcontractualdata?.turpe && memberorderElectricityTurpeVersionC5.find((x) => x.id == data.parameters?.pdloldcontractualdata?.turpe).name}</ElementData>
                      </ExpandableElement>
                      {((data.parameters?.pdloldcontractualdata?.turpe === 'cu' && data.parameters?.pdloldcontractualdata?.pdltype === 'C5bat') ||
                        (data.parameters?.pdloldcontractualdata?.pdltype === 'C5ecl')) &&
                        <ExpandableElement>
                          <ElementTitle>{memberorder.electricity.psousbase} : </ElementTitle>
                          <ElementData>{data.parameters?.pdloldcontractualdata?.psousbase}</ElementData>
                        </ExpandableElement>
                      }
                      {((data.parameters?.pdloldcontractualdata?.turpe === 'mu' && data.parameters?.pdloldcontractualdata?.pdltype === 'C5bat')) &&
                        <>
                          <ExpandableElement>
                            <ElementTitle>{memberorder.electricity.psoushp} : </ElementTitle>
                            <ElementData>{data.parameters?.pdloldcontractualdata?.psoushp}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{memberorder.electricity.psoushc} : </ElementTitle>
                            <ElementData>{data.parameters?.pdloldcontractualdata?.psoushc}</ElementData>
                          </ExpandableElement>
                        </>
                      }
                      {((data.parameters?.pdloldcontractualdata?.turpe === 'lu' && data.parameters?.pdloldcontractualdata?.pdltype === 'C5bat') ||
                        (data.parameters?.pdloldcontractualdata?.pdltype === 'C4') || (data.parameters?.pdloldcontractualdata?.pdltype === 'C3') || (data.parameters?.pdloldcontractualdata?.pdltype === 'C2')) &&
                        <>
                          <ExpandableElement>
                            <ElementTitle>{memberorder.electricity.psoushph} : </ElementTitle>
                            <ElementData>{data.parameters?.pdloldcontractualdata?.psoushph}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{memberorder.electricity.psoushch} : </ElementTitle>
                            <ElementData>{data.parameters?.pdloldcontractualdata?.psoushch}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{memberorder.electricity.psoushpe} : </ElementTitle>
                            <ElementData>{data.parameters?.pdloldcontractualdata?.psoushpe}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{memberorder.electricity.psoushce} : </ElementTitle>
                            <ElementData>{data.parameters?.pdloldcontractualdata?.psoushce}</ElementData>
                          </ExpandableElement>
                        </>
                      }
                      {((data.parameters?.pdloldcontractualdata?.pdltype === 'C3') || (data.parameters?.pdloldcontractualdata?.pdltype === 'C2')) &&
                        <>
                          <ExpandableElement>
                            <ElementTitle>{memberorder.electricity.psouspointe} : </ElementTitle>
                            <ElementData>{data.parameters?.pdloldcontractualdata?.psouspointe}</ElementData>
                          </ExpandableElement>
                        </>
                      }
                      {((data.parameters?.pdloldcontractualdata?.pdltype === 'C5ecl')) &&
                        <>
                          <ExpandableElement>
                            <ElementTitle>{memberorder.electricity.nbhour} : </ElementTitle>
                            <ElementData>{data.parameters?.pdloldcontractualdata?.nbhour && memberorderElectricityEclHourCount.find((x) => x.id == data.parameters?.pdloldcontractualdata?.nbhour).name}</ElementData>
                          </ExpandableElement>
                        </>
                      }
                    </>
                  }
                  {(market?.parameters?.general?.energy === 'gas') &&
                    <>
                      <ExpandableElement>
                        <ElementTitle>{memberorder.gas.profil} : </ElementTitle>
                        <ElementData>{data.parameters?.pdloldcontractualdata?.profil && memberorderGasProfil.find((x) => x.id == data.parameters?.pdloldcontractualdata?.profil).name}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{memberorder.gas.tarif} : </ElementTitle>
                        <ElementData>{data.parameters?.pdloldcontractualdata?.tarif && memberorderGasTariff.find((x) => x.id == data.parameters?.pdloldcontractualdata?.tarif).name}</ElementData>
                      </ExpandableElement>
                    </>
                  }
                </>
              </>
            }
            {(ordertype !== 'detach') &&
              <>
                <ElementSectionTitle>Informations du Point de livraison souhaitées</ElementSectionTitle>
                {((ordertype === 'attachmeter' || ordertype === 'provis')) &&
                  <ExpandableElement>
                    <ElementTitle>{memberorder.pdl} : </ElementTitle>
                    <ElementData>{data.parameters?.pdl}</ElementData>
                  </ExpandableElement>
                }
                <ExpandableElement>
                  <ElementTitle>{memberorder.pdlname} : </ElementTitle>
                  <ElementData>{data.parameters?.pdlname}</ElementData>
                </ExpandableElement>
                <ExpandableElement>
                  <ElementTitle>{memberorder.pdladdress} : </ElementTitle>
                  <ElementData>{data.parameters?.pdladdress?.description}</ElementData>
                </ExpandableElement>

                <ExpandableElement>
                  <ElementTitle>{memberorder.pdlinseecode} : </ElementTitle>
                  <ElementData>{data.parameters?.pdlinseecode}</ElementData>
                </ExpandableElement>


                <ExpandableElement>
                  <ElementTitle>{memberorder.pdlreferenceconsumption} : </ElementTitle>
                  <ElementData>{data.parameters?.pdlreferenceconsumption}</ElementData>
                </ExpandableElement>
                <ExpandableElement>
                  <ElementTitle>{memberorder.executiondate} : </ElementTitle>
                  <ElementData>{data.parameters.startdate && moment(data.parameters.startdate).isValid()
                    ? moment(data.parameters.startdate).format("DD/MM/YYYY")
                    : ""}</ElementData>
                </ExpandableElement>
                {(ordertype === 'provis') &&
                  <ExpandableElement>
                    <ElementTitle>{memberorder.enddate} : </ElementTitle>
                    <ElementData>{data.parameters.enddate && moment(data.parameters.enddate).isValid()
                      ? moment(data.parameters.enddate).format("DD/MM/YYYY")
                      : ""}</ElementData>
                  </ExpandableElement>
                }
                {(ordertype === 'attachmeter' || ordertype === 'provis') &&
                  <>
                    {(market?.parameters?.general?.energy === 'electricity') &&
                      <ExpandableElement>
                        <ElementTitle>{memberorder.renewablemix} : </ElementTitle>
                        <ElementData>{data.parameters?.renewablemix && memberorderElectricityRenewableMix.find((x) => x.id == data.parameters?.renewablemix).name}</ElementData>
                      </ExpandableElement>
                    }
                    <ExpandableElement>
                      <ElementTitle>{memberorder.billregroupname} : </ElementTitle>
                      <ElementData>{data.parameters?.billregroupname}</ElementData>
                    </ExpandableElement>
                    <ExpandableElement>
                      <ElementTitle>{memberorder.billregroupcode} : </ElementTitle>
                      <ElementData>{data.parameters?.billregroupcode}</ElementData>
                    </ExpandableElement>
                    <ExpandableElement>
                      <ElementTitle>{memberorder.billbudgetcode} : </ElementTitle>
                      <ElementData>{data.parameters?.billbudgetcode}</ElementData>
                    </ExpandableElement>
                  </>
                }
                <ElementSectionTitle>Données contractuelles souhaitées</ElementSectionTitle>
                {(market?.parameters?.general?.energy === 'electricity') &&
                  <>
                    <ExpandableElement>
                      <ElementTitle>{memberorder.electricity.pdltype} : </ElementTitle>
                      <ElementData>{data.parameters?.pdlcontractualdata?.pdltype && memberorderElectricitySegment.find((x) => x.id == data.parameters?.pdlcontractualdata?.pdltype).name}</ElementData>
                    </ExpandableElement>
                    <ExpandableElement>
                      <ElementTitle>{memberorder.electricity.turpe} : </ElementTitle>
                      <ElementData>{data.parameters?.pdlcontractualdata?.turpe && memberorderElectricityTurpeVersionC5.find((x) => x.id == data.parameters?.pdlcontractualdata?.turpe).name}</ElementData>
                    </ExpandableElement>
                    {((data.parameters?.pdlcontractualdata?.turpe === 'cu' && data.parameters?.pdlcontractualdata?.pdltype === 'C5bat') ||
                      (data.parameters?.pdlcontractualdata?.pdltype === 'C5ecl')) &&
                      <ExpandableElement>
                        <ElementTitle>{memberorder.electricity.psousbase} : </ElementTitle>
                        <ElementData>{data.parameters?.pdlcontractualdata?.psousbase}</ElementData>
                      </ExpandableElement>
                    }
                    {((data.parameters?.pdlcontractualdata?.turpe === 'mu' && data.parameters?.pdlcontractualdata?.pdltype === 'C5bat')) &&
                      <>
                        <ExpandableElement>
                          <ElementTitle>{memberorder.electricity.psoushp} : </ElementTitle>
                          <ElementData>{data.parameters?.pdlcontractualdata?.psoushp}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{memberorder.electricity.psoushc} : </ElementTitle>
                          <ElementData>{data.parameters?.pdlcontractualdata?.psoushc}</ElementData>
                        </ExpandableElement>
                      </>
                    }
                    {((data.parameters?.pdlcontractualdata?.turpe === 'lu' && data.parameters?.pdlcontractualdata?.pdltype === 'C5bat') ||
                      (data.parameters?.pdlcontractualdata?.pdltype === 'C4') || (data.parameters?.pdlcontractualdata?.pdltype === 'C3') || (data.parameters?.pdlcontractualdata?.pdltype === 'C2')) &&
                      <>
                        <ExpandableElement>
                          <ElementTitle>{memberorder.electricity.psoushph} : </ElementTitle>
                          <ElementData>{data.parameters?.pdlcontractualdata?.psoushph}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{memberorder.electricity.psoushch} : </ElementTitle>
                          <ElementData>{data.parameters?.pdlcontractualdata?.psoushch}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{memberorder.electricity.psoushpe} : </ElementTitle>
                          <ElementData>{data.parameters?.pdlcontractualdata?.psoushpe}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{memberorder.electricity.psoushce} : </ElementTitle>
                          <ElementData>{data.parameters?.pdlcontractualdata?.psoushce}</ElementData>
                        </ExpandableElement>
                      </>
                    }
                    {((data.parameters?.pdlcontractualdata?.pdltype === 'C3') || (data.parameters?.pdlcontractualdata?.pdltype === 'C2')) &&
                      <>
                        <ExpandableElement>
                          <ElementTitle>{memberorder.electricity.psouspointe} : </ElementTitle>
                          <ElementData>{data.parameters?.pdlcontractualdata?.psouspointe}</ElementData>
                        </ExpandableElement>
                      </>
                    }
                    {((data.parameters?.pdlcontractualdata?.pdltype === 'C5ecl')) &&
                      <>
                        <ExpandableElement>
                          <ElementTitle>{memberorder.electricity.nbhour} : </ElementTitle>
                          <ElementData>{data.parameters?.pdlcontractualdata?.nbhour && memberorderElectricityEclHourCount.find((x) => x.id == data.parameters?.pdlcontractualdata?.nbhour).name}</ElementData>
                        </ExpandableElement>
                      </>
                    }
                  </>
                }
                {(market?.parameters?.general?.energy === 'gas') &&
                  <>
                    <ExpandableElement>
                      <ElementTitle>{memberorder.gas.profil} : </ElementTitle>
                      <ElementData>{data.parameters?.pdlcontractualdata?.profil && memberorderGasProfil.find((x) => x.id == data.parameters?.pdlcontractualdata?.profil).name}</ElementData>
                    </ExpandableElement>
                    <ExpandableElement>
                      <ElementTitle>{memberorder.gas.tarif} : </ElementTitle>
                      <ElementData>{data.parameters?.pdlcontractualdata?.tarif && memberorderGasTariff.find((x) => x.id == data.parameters?.pdlcontractualdata?.tarif).name}</ElementData>
                    </ExpandableElement>
                  </>
                }

              </>
            }



          </>
        }
      </ExpandableContainer>
    </Container>
  );
};

const downloadGED = (fileId, fileName) => async () => {
  axios
    .get(
      downloadFile(fileId),
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};


const useStyles = makeStyles(styles);

const RTServiceOrders = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const markets_update = permis.includes("markets_update");
  const markets_admin = permis.includes("markets_admin");
  const { gridState, refetch, setSelectedOrders } = useServiceOrderTable();
  const marketContext = useContext(MarketsContext);
  const { market, setMarket } = marketContext;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const [open, setOpen] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [openValidateOrder, setOpenValidateOrder] = useState(false);
  const [openSendOrder, setOpenSendOrder] = useState(false);
  const [openAddMeter, setOpenAddMeter] = useState(false);
  const [openEditMeter, setOpenEditMeter] = useState(false);
  const [currentServiceOrder, setCurrentServiceOrder] = useState(null);

  let dataOrders = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: memberorder.pdl,
      selector: (row) => row.parameters.pdl,
      sortable: true,
      maxWidth: "13rem",
    },
    {
      name: memberorder.pdlname,
      selector: (row) => row.parameters.pdlname,
      sortable: true,
      maxWidth: "13rem",
    },
    {
      name: memberorder.numeroaffaire,
      selector: (row) => row.parameters.numeroaffaire,
      sortable: true,
      maxWidth: "13rem",
    },
    {
      name: memberorder.ordertype,
      selector: (row) => row.parameters.ordertype,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => memberorderTypeData.find((x) => x.id == row.parameters.ordertype).name
    },
    {
      name: memberorder.author,
      selector: (row) => row.parameters.author,
      sortable: true,
      maxWidth: "13rem",
      cell: (row) =>
        <div>
          {row.parameters.author}
        </div>
    },
    {
      name: memberorder.marketmembershipnumber,
      selector: (row) => row.marketmembershipnumber,
      sortable: true,
      maxWidth: "9rem",
    },
    {
      name: memberorder.marketmembershipname,
      selector: (row) => row.marketmembershipname,
      sortable: true,
      maxWidth: "9rem",
    },
    {
      id: "creationdatecol",
      name: memberorder.creationdate,
      selector: (row) => row.parameters.creationdate,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.parameters.creationdate && moment(row.parameters.creationdate).isValid()
          ? moment(row.parameters.creationdate).format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: memberorder.executiondate,
      selector: (row) => row.parameters.startdate ? row.parameters.startdate : row.parameters.enddate,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.parameters.startdate && moment(row.parameters.startdate).isValid()
          ? moment(row.parameters.startdate).format("DD/MM/YYYY")
          : row.parameters.enddate && moment(row.parameters.enddate).isValid()
            ? moment(row.parameters.enddate).format("DD/MM/YYYY")
            : "",
    },
    {
      name: memberorder.status,
      selector: (row) => row.parameters.status,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters.status ?
        <div style={{ color: memberorderStatusData.find((x) => x.id == row.parameters.status).color, fontWeight: "bold" }}>
          {memberorderStatusData.find((x) => x.id == row.parameters.status).name}
        </div> : <></>
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {
              markets_update && row.parameters.status === 'membervalidation' &&
              <Tooltip title="Valider l'ordre de service">
                <Button
                  onClick={validateServiceOrder(row)}
                  color={"success"}
                  className={classes.actionButton}
                >
                  <CheckIcon fontSize="large" />
                </Button>
              </Tooltip>
            }
            {
              markets_admin && row.parameters.status === 'sent' &&
              <Tooltip title="Soumettre l'ordre de service">
                <Button
                  onClick={sendServiceOrder(row)}
                  color={"success"}
                  className={classes.actionButton}
                >
                  <CheckIcon fontSize="large" />
                </Button>
              </Tooltip>
            }
            {
              markets_admin && (row.parameters.status === 'validated') &&
              (row.parameters.ordertype === 'change' ?
                <CustomConfirmationButton
                  dialogtitle={"Valider l'exécution de l'ordre de service"}
                  subTitle={`Êtes-vous sûr de vouloir valider l'exécution de l'ordre de service?`}
                  confirmation={"Valider"}
                  icon={<CheckIcon fontSize="large" />}
                  tooltip={"Valider l'exécution de l'ordre de service"}
                  color="warning"
                  handleConfirmation={validateServiceOrderexectutionFunction(row)}
                />

                :
                <CustomConfirmationButtonMultipleChoices
                  dialogtitle={"Valider l'exécution de l'ordre de service"}
                  subTitle={`Êtes-vous sûr de vouloir valider l'exécution de l'ordre de service?`}
                  confirmation={"Valider"}
                  confirmation2={"Valider avec mise à jour du patrimoine"}
                  icon={<CheckIcon fontSize="large" />}
                  tooltip={"Valider l'exécution de l'ordre de service"}
                  color="warning"
                  color2="success"
                  handleConfirmation={validateServiceOrderexectutionFunction(row)}
                  handleConfirmation2={validateServiceOrderexectutionFunction2(row)}
                />
              )
            }
            {
              markets_admin && (row.parameters.status === 'sent' || row.parameters.status === 'validated') &&

              <CustomConfirmationButton
                dialogtitle={"Invalider l'ordre de service"}
                subTitle={`Êtes-vous sûr de vouloir invalider l'ordre de service?`}
                confirmation={"Invalider"}
                icon={<ClearIcon fontSize="large" />}
                tooltip={"Invalider l'ordre de service"}
                color="danger"
                handleConfirmation={invalidateServiceOrderFunction(row)}
              />
            }

            {/* {
              markets_admin && row.parameters.status !== 'membervalidation' &&
              <Tooltip title="Changer le statut">
                <Button
                  onClick={editServiceOrderStatus(row)}
                  color={"info"}
                  className={classes.actionButton}
                >
                  <ExitToAppIcon fontSize="large" />
                </Button>
              </Tooltip>
            } */}
            {
              ((markets_update && row.parameters.status === 'membervalidation') ||
                (markets_admin && row.parameters.status !== 'sent')) &&
              <Tooltip title="Editer l'ordre de service'">
                <Button
                  onClick={editServiceOrder(row)}
                  color={"warning"}
                  className={classes.actionButton}
                >
                  <EditIcon fontSize="large" />
                </Button>
              </Tooltip>
            }
            {((markets_update && row.parameters.status === 'membervalidation') || (markets_admin)) &&
              <Tooltip title="Supprimer l'ordre de service'">
                <CustomDeleteButton
                  deleteTitle={"Suppression de l'ordre de service"}
                  deleteSubTitle={`Êtes-vous sûr de vouloir supprimer l'ordre de service?`}
                  handleSupprimer={deleteServiceOrderFunction(row)}
                />
              </Tooltip>
            }

          </div>
        </>
      ),
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const handleClickStatusOpen = () => {
    setOpenStatus(true);
  };
  const handleEditStatusClose = () => {
    setOpenStatus(false);
  };

  const handleClickValidateOrderOpen = () => {
    setOpenValidateOrder(true);
  };
  const handleClickValidateOrderClose = () => {
    setOpenValidateOrder(false);
  };
  const handleClickSendOrderOpen = () => {
    setOpenSendOrder(true);
  };
  const handleClickSendOrderClose = () => {
    setOpenSendOrder(false);
  };

  const handleClickAddMeterOpen = () => {
    setOpenAddMeter(true);
  };
  const handleClickAddMeterClose = () => {
    setOpenAddMeter(false);
  };

  const handleClickEditMeterOpen = () => {
    setOpenEditMeter(true);
  };
  const handleClickEditMeterClose = () => {
    setOpenEditMeter(false);
  };

  const editServiceOrder = (row) => async () => {
    let obj = dataOrders.find((o) => o.id === row.id);
    if (obj) {
      setCurrentServiceOrder(obj);
      handleClickOpen();
    }
  }

  const editServiceOrderStatus = (row) => async () => {
    let obj = dataOrders.find((o) => o.id === row.id);
    if (obj) {
      setCurrentServiceOrder(obj);
      handleClickStatusOpen();
    }
  }

  const validateServiceOrder = (row) => async () => {
    let obj = dataOrders.find((o) => o.id === row.id);
    if (obj) {
      setCurrentServiceOrder(obj);
      handleClickValidateOrderOpen();
    }
  }

  const sendServiceOrder = (row) => async () => {
    let obj = dataOrders.find((o) => o.id === row.id);
    if (obj) {
      setCurrentServiceOrder(obj);
      handleClickSendOrderOpen();
    }
  }

  const invalidateServiceOrderFunction = (row) => async () => {
    let obj = dataOrders.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = putMarketMembershipOrder(idSelected, market.id);
    axios
      .put(url,
        {
          serviceorderparameters:
          {
            ...obj.parameters,
            status: 'membervalidation',
            generatedfile: ''
          }
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },

        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `L'ordre de service a été invalidé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const validateServiceOrderexectutionFunction = (row) => async () => {
    let obj = dataOrders.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = putMarketMembershipOrder(idSelected, market.id);
    axios
      .put(url,
        {
          serviceorderparameters:
          {
            ...obj.parameters,
            status: 'executed',
          }
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },

        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `L'ordre de service a été validé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const validateServiceOrderexectutionFunction2 = (row) => async () => {
    let obj = dataOrders.find((o) => o.id === row.id);
    let idSelected = obj.id;
    setCurrentServiceOrder(obj);
    if (obj.parameters.ordertype === 'attachmeter' || obj.parameters.ordertype === 'provis')
      handleClickAddMeterOpen();
    else if (obj.parameters.ordertype === 'detach')
      handleClickEditMeterOpen();
    else if (obj.parameters.ordertype === 'change')
      handleClickEditMeterOpen();
  };

  const deleteServiceOrderFunction = (row) => async () => {
    let obj = dataOrders.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteMarketMembershipOrder(idSelected);
    axios
      .delete(url, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `L'ordre de service a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedOrders(selection.selectedRows);
  };

  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        noDataComponent={<NoData>Aucun ordre de service à afficher</NoData>}
        noHeader={true}
        defaultSortFieldId={"creationdatecol"}
        defaultSortAsc={false}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        expandOnRowClicked
        expandableRows
        expandableRowDisabled={(row) => row.disabled}
        expandableRowsComponent={ExpandableComponent}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          Modification de l'ordre de service
        </CustomDialogTitle>
        <DialogContent dividers>
          <EditServiceOrderDialog
            serviceorder={currentServiceOrder}
            closeModal={handleEditClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleEditStatusClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openStatus}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditStatusClose}>
          Modification de l'ordre de service
        </CustomDialogTitle>
        <DialogContent dividers>
          <EditServiceOrderStatusDialog
            serviceorder={currentServiceOrder}
            market={market}
            closeModal={handleEditStatusClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleClickValidateOrderClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openValidateOrder}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleClickValidateOrderClose}>
          Validation de l'ordre de service
        </CustomDialogTitle>
        <DialogContent dividers>
          <ValidateServiceOrderDialog
            serviceorder={currentServiceOrder}
            market={market}
            closeModal={handleClickValidateOrderClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleClickSendOrderClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openSendOrder}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleClickSendOrderClose}>
          Validation et envoi de l'ordre de service
        </CustomDialogTitle>
        <DialogContent dividers>
          <SendServiceOrderDialog
            serviceorder={currentServiceOrder}
            market={market}
            closeModal={handleClickSendOrderClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleClickAddMeterClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openAddMeter}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleClickAddMeterClose}>
          Exécution de l'ordre de service
        </CustomDialogTitle>
        <DialogContent dividers>
          <AddMeterToAccountDialog
            serviceorder={currentServiceOrder}
            market={market}
            closeModal={handleClickAddMeterClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleClickEditMeterClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openEditMeter}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleClickEditMeterClose}>
          Exécution de l'ordre de service
        </CustomDialogTitle>
        <DialogContent dividers>
          <EditMeterAccountDialog
            serviceorder={currentServiceOrder}
            market={market}
            closeModal={handleClickEditMeterClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTServiceOrders;
